import { render, staticRenderFns } from "./salesInCarInventory.vue?vue&type=template&id=6bd3d95c&"
import script from "./salesInCarInventory.vue?vue&type=script&lang=js&"
export * from "./salesInCarInventory.vue?vue&type=script&lang=js&"
import style0 from "./salesInCarInventory.vue?vue&type=style&index=0&id=6bd3d95c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports